var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,6,7,7V8L6,9H5L4,8V7L5,6Zm17.62,5.29-8-8-.26-.18-2-1L12.91,2H11.5l6,6,4.41,4.41v1.18l-4.14,4.15L16.5,19l-1.88,1.88.29.12h2l.71-.29,6-6,.29-.71V12Zm-4.91,3.42-6,6L12,21H10l-.71-.29-8-8-.18-.26-1-2L0,10V5l.29-.71,2-2L3,2H8l.45.11,2,1,.26.18,8,8L19,12v2ZM17,12.41,9.41,4.82,7.76,4H3.41L2,5.41V9.76l.82,1.65L10.41,19h1.18L17,13.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTags);
export default __webpack_public_path__ + "static/1770312069/media/icon-tags.0319616cc1c1d9eed36bff622849389d.svg";
export { ForwardRef as ReactComponent };